import { useCallback, useMemo, useState } from "react"
import { TrialResult, useListTrial } from "interface/trial"
import { SearchDetailResult } from "interface/search"

import { Grid, useGrid } from "components/grid"
import { GridRowId } from "@mui/x-data-grid"

import { useTrialGridColumns } from "./columns"
import { TrialPreviewDialog } from "features/trial/dialog/preview"

type TrialPageProps = {
	search: SearchDetailResult
} & ReturnType<typeof useGrid>
export const TrialPage = ({
	search,
	...others
}: TrialPageProps) => {
	const [selectedTrial, setSelectedTrial] = useState<TrialResult | null>(null)
	const listState = useListTrial(search.searchId, undefined, { updateTime: search.updateTime })
	const progress = useMemo(
		() => listState.loaded && listState.total ? (listState.loaded / listState.total) * 100 : undefined,
		[listState]
	)
	const onClickLink = useCallback(
		(id: GridRowId) => setSelectedTrial(listState.data?.at(id as number) ?? null),
		[setSelectedTrial, listState]
	)
	const { columnsDef } = useTrialGridColumns({ onClickLink })
	return (
		<>
			<Grid
				{...others}
				saveKey="trial_grid"
				baseFileName={search.title}
				sheetName="治験"
				loading={listState.loading}
				progress={progress}
				columnsDef={columnsDef}
				dataList={listState.data ?? []}
				onDblClick={setSelectedTrial}
			/>
			{selectedTrial ? (
				<TrialPreviewDialog
					trial={selectedTrial}
					onClose={() => setSelectedTrial(null)}
				/>
			) : <></>}
		</>
	)
}